import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/index.js'

const HomeDashboard = () => import( /* webpackChunkName: "admin1" */ '@/components/home-dashboard-dyn')
const DCDashboard = () => import( /* webpackChunkName: "admin1" */ '@/components/DC-dashboard-dyn')
const HomeScreen = () => import( /* webpackChunkName: "admin1" */ '@/components/admin/home-screen')
const V4ExploratoryScreen = () => import( /* webpackChunkName: "admin1" */ '@/components/admin/v4-exploratory-screen')
const BusinessGlossaryScreen = () => import( /* webpackChunkName: "admin1" */ '@/components/admin/business-glossary-screen')
const mRetailerScreen = () => import( /* webpackChunkName: "admin1" */ '@/components/admin/m-retailer-screen')
const About = () => import( /* webpackChunkName: "admin1" */ '@/components/about')
const ReleaseNotes = () => import( /* webpackChunkName: "admin1" */ '@/components/release-notes')
const ChangePass = () => import( /* webpackChunkName: "admin1" */ '@/components/change_password')
const ResetPass = () => import( /* webpackChunkName: "admin1" */ '@/components/admin/reset_password')
const ForgetPass = () => import( /* webpackChunkName: "admin1" */ '@/components/forget_password')
const DrilldownA1 = () => import( /* webpackChunkName: "drilldown" */ '@/components/dynamic-dashboard/drilldown-a1')
const DrilldownA = () => import( /* webpackChunkName: "drilldown" */ '@/components/dynamic-dashboard/drilldown-a')
const DrilldownB1 = () => import( /* webpackChunkName: "drilldown" */ '@/components/dynamic-dashboard/drilldown-b1')
const DrilldownB = () => import( /* webpackChunkName: "drilldown" */ '@/components/dynamic-dashboard/drilldown-b')
const Pcat1 = () => import( /* webpackChunkName: "pcat" */ '@/components/r-charts/pcat1')
const Pcat2 = () => import( /* webpackChunkName: "pcat" */ '@/components/r-charts/pcat2')
const Pcat3 = () => import( /* webpackChunkName: "pcat" */ '@/components/r-charts/pcat3')
const RfmSegment = () => import( /* webpackChunkName: "rfm" */ '@/components/r-charts/rfm-segment')
const RfmScore = () => import( /* webpackChunkName: "rfm" */ '@/components/r-charts/rfm-score')
const Page = () => import( /* webpackChunkName: "admin1" */ '@/components/new-db-page')
const Page1 = () => import( /* webpackChunkName: "admin1" */ '@/components/page1')
const salesmanDashboard = () => import( /* webpackChunkName: "admin1" */ '@/components/screenlet_seq_test_2')
const seqPage = () => import( /* webpackChunkName: "admin1" */ '@/components/screenlet_seq_test_2')
const flexiSeqPage = () => import('@/components/flexi_screenlet.vue')
const Login = () => import( /* webpackChunkName: "admin1" */ '@/components/login')
const Logout = () => import( /* webpackChunkName: "admin1" */ '@/components/logout')
const RoleSwitch = () => import( /* webpackChunkName: "admin1" */ '@/components/roleScreen')
const CustomerDrilldown = () => import( /* webpackChunkName: "drilldown" */ '@/components/reports/customer-drilldown')
const DynamicDrilldown = () => import( /* webpackChunkName: "drilldown" */ '@/components/reports/drilldown-report-page')
const MDMDrilldown = () => import( /* webpackChunkName: "drilldown" */ '@/components/reports/drilldown-report-page-mdm')
const ProductDrilldown = () => import( /* webpackChunkName: "drilldown" */ '@/components/reports/product-drilldown')
const SalesmanDrilldown = () => import( /* webpackChunkName: "drilldown" */ '@/components/reports/sales-man-drilldown')
const leafletMapPopup = () => import( /* webpackChunkName: "admin2" */ '@/components/leafletMapPopup')
const newmapleaflet = () => import( /* webpackChunkName: "admin2" */ '@/components/newmapleaflet')
const RFM = () => import( /* webpackChunkName: "admin2" */ '@/components/reports/rfm')
const BarChart = () => import( /* webpackChunkName: "admin2" */ '@/components/BarChart')
const MenuMasterScreen = () => import( /* webpackChunkName: "admin2" */ '@/components/admin/menu-master-screen')
const SalesPersonScreen = () => import( /* webpackChunkName: "admin2" */ '@/components/admin/sales-person-screen')
const VizTypeScreen = () => import( /* webpackChunkName: "admin2" */ '@/components/admin/viztype-screen')
const ReportMasterScreen = () => import( /* webpackChunkName: "admin2" */ '@/components/admin/reportmaster-screen')
const Compare = () => import( /* webpackChunkName: "admin2" */ '@/components/screen')
const simpleReportPageBiz = () => import( /* webpackChunkName: "admin3" */ '@/components/reports/simple-report-page-temp-usr-biz-actions')
const simpleReportPage = () => import( /* webpackChunkName: "admin3" */ '@/components/reports/simple-report-page')
const Crossfilter = () => import( /* webpackChunkName: "admin3" */ '@/components/crossfilter-page')
const Crossfilterdc = () => import( /* webpackChunkName: "admin3" */ '@/components/crossfilterdc-page')
const Horizontalbar = () => import( /* webpackChunkName: "admin3" */ '@/components/horizontalbar-page')
const TogglePage = () => import( /* webpackChunkName: "admin3" */ '@/components/togglepage')
const MBAnwGraph = () => import( /* webpackChunkName: "admin3" */ '@/components/mba-nw-graph')
const TravelsHomeDashboard = () => import( /* webpackChunkName: "admin3" */ '@/components/travels-home-dashboard')
const dendropdownpage = () => import( /* webpackChunkName: "admin5" */ '@/components/dendropdownpage')
const updating_metricspage = () => import( /* webpackChunkName: "admin5" */ '@/components/updating_metricspage')
const XYDrilldown = () => import( /* webpackChunkName: "admin5" */ '@/components/admin/xy-drilldown')
const fileUpload = () => import( /* webpackChunkName: "admin5" */ '@/components/file-upload')
const mdmForm = () => import( /* webpackChunkName: "admin5" */ '@/components/reports/mdm-form-report')
const pivotTableComplete = () => import( /* webpackChunkName: "admin5" */ '@/components/pivotTableComplete')
const zclient_id_20_mmt_pivotTable = () => import( /* webpackChunkName: "admin5" */ '@/components/zclient_id_specific/zclient_id_20_mmt_pivotTable')
const pivotTableCompleteRetail = () => import( /* webpackChunkName: "admin6" */ "@/components/pivotTableCompleteRetail")
const pivotTableCompleteDuroflex = () => import( /* webpackChunkName: "admin6" */ '@/components/pivotTableCompleteDuroflex')
const singleReportPagination = () => import( /* webpackChunkName: "admin6" */ '@/components/reports/simple-report-with-pagination')
const compareReport = () => import( /* webpackChunkName: "admin6" */ '@/components/reports/compare-report-table.vue')
const fieldDryReport = () => import( /* webpackChunkName: "admin6" */ '@/components/zclient_id_specific/zclient-id-20-mmt-field-dry-report-screen.vue')
const fieldWetReport = () => import( /* webpackChunkName: "admin6" */ '@/components/zclient_id_specific/zclient-id-20-mmt-field-wet-report-screen.vue')
const fieldHlgReport = () => import( /* webpackChunkName: "admin6" */ '@/components/zclient_id_specific/zclient-id-20-mmt-field-hlg-report-screen.vue')
const CreateUser = () => import( /* webpackChunkName: "admin6" */ '@/components/admin/create-users.vue')
const AssignRole = () => import( /* webpackChunkName: "admin7" */ '@/components/admin/assign-role.vue')
const invalidPage = () => import( /* webpackChunkName: "admin7" */ '@/components/invalid-page')
const excitareFieldValidation = () => import( /* webpackChunkName: "admin7" */ '@/components/reports/excitare_field_validation.vue')
const tabulatorReportTable = () => import('@/components/reports/tabulator-report-table.vue')
const bslAPiPage = () => import('@/components/BslApiComponent.vue')
const mobileDashboardPage = () => import('@/components/MobileScreenlet.vue')
const configMenu = () => import('@/components/admin/menu-config.vue')

const imageDisplay = () => import( /* webpackChunkName: "admin1" */ '@/components/imageDisplay')

import jwtDecode from "jwt-decode";
import {isDescendant} from "@/common/functions";
//import jwtDecode from "jwt-decode";

Vue.use(Router)
const router = new Router({
    // mode: 'history',
    routes: [

        {
            path: '/',
            name: 'home',
            //redirect: '/home/Root/A'
            component: HomeDashboard,
            meta: { requiresAuth: true }
        },
        {
            path: '/about',
            name: 'about',
            component: About,
            meta: { requiresAuth: true }
        },
        {
            path: '/release-notes',
            name: 'releaseNote',
            component: ReleaseNotes,
            meta: { requiresAuth: true }
        },
        {
            path: '/change-password',
            name: 'changepass',
            component: ChangePass,
        },
        {
            path: '/reset-password/:menuId/:submenuId',
            name: 'resetpass',
            component: ResetPass
        },
        {
            path: '/forget-password',
            name: 'forgetpass',
            component: ForgetPass
        },
        {
            path: '/user-restrict',
            name: 'invalidPage',
            component: invalidPage
        },
        {
            path: '/create-user/:menuId/:submenuId',
            name: 'create-user',
            component: CreateUser,
            meta: { requiresAuth: true }
        },
        {
            path: '/assign-role/:menuId/:submenuId',
            name: 'assign-role',
            component: AssignRole,
            meta: { requiresAuth: true }
        },
        {
            path: '/login',
            name: 'login',
            component: Login
        },
        {
            path: '/logout',
            name: 'logout',
            component: Logout
        },
        {
            path: '/roleScreen',
            name: 'roleScreen',
            component: RoleSwitch
        },
        {
            path: '/home/:menuId/:submenuId',
            name: 'home-m-s',
            component: HomeDashboard,
            meta: { requiresAuth: true }
        },
        {
            path: '/DC/:menuId/:submenuId',
            name: 'DC-dash',
            component: DCDashboard,
            meta: { requiresAuth: true }
        },
        {   // post-load menu path for post submit loading viz screen
            path: '/post-load/:menuId/:submenuId',
            name: 'post-load-screen',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true },
        },
        {   // this menu path is for flexi-viz
            path: '/flexi-viz/:menuId/:submenuId',
            name: 'flexi-viz-screen',
            component: flexiSeqPage,
            meta: { requiresFlexiScreenConfig: true , requiresAuth: true}
        },
        {   // compare menu path for comparison dashboard
            path: '/compare/:menuId/:submenuId',
            name: 'comparison-dashboard',
            component: Compare,
            meta: { requiresAuth: true }
        },
        {   // viz-screen menu path for pre loading viz screen
            path: '/viz-screen/:menuId/:submenuId',
            name: 'visualisation-screen',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {   // drilldown-report path for dynamic drilldown report
            path: '/drilldown-report/:menuId/:submenuId',
            name: 'drilldown-report-page',
            component: DynamicDrilldown,
            meta: { requiresDrilldownConfig: true , requiresAuth: true}
        },
        {   // drilldown-report path for dynamic drilldown report
            path: '/drilldown-report-mdm/:menuId/:submenuId',
            name: 'drilldown-report-page-mdm',
            component: MDMDrilldown,
            meta: { requiresAuth: true }
        },
        {   // report path for simple report screen
            path: '/report/:menuId/:submenuId',
            name: 'simple-report-page',
            component: simpleReportPage,
            meta: { requiresAuth: true }
        },
        {   // report path for simple report screen with Business action icons
            path: '/reportActions/:menuId/:submenuId',
            name: 'simple-report-page-ra',
            component: simpleReportPageBiz,
            meta: { requiresAuth: true }
        },
        {   // file-upload for file upload screen
            path: '/file-upload/:menuId/:submenuId',
            name: 'file_upload',
            component: fileUpload,
            meta: { requiresAuth: true }
        },
        {   // mdm-insert update screen
            path: '/mdm-form/:menuId/:submenuId',
            name: 'mdm_form',
            component: mdmForm,
            meta:{ requiresMdmConfig: true , requiresAuth: true}
        },
        {   // compare report for product specification comparison
            path: '/compare-report/:menuId/:submenuId',
            name: 'compare-report',
            component: compareReport,
            meta: { requiresAuth: true }
        },
        {   // compare report for product specification comparison
            path: '/field-dry-report/:menuId/:submenuId',
            name: 'field-dry-report',
            component: fieldDryReport,
            meta: { requiresAuth: true }
        },
        {   // compare report for product specification comparison
            path: '/field-wet-report/:menuId/:submenuId',
            name: 'field-wet-report',
            component: fieldWetReport,
            meta: { requiresAuth: true }
        },
        {   // compare report for product specification comparison
            path: '/field-hlg-report/:menuId/:submenuId',
            name: 'field-hlg-report',
            component: fieldHlgReport,
            meta: { requiresAuth: true }
        },
        {
            path: '/excitare_field_valiation/:menuId/:submenuId',
            name: 'excitare_field_valiation',
            component: excitareFieldValidation,
            meta: { requiresAuth: true }
        },
        {
            path: '/pvt/:menuId/:submenuId',
            name: 'pivotTable',
            component: zclient_id_20_mmt_pivotTable,
            meta: { requiresAuth: true }
        },
        {
            path: '/pvtb/:menuId/:submenuId',
            name: 'pivotTable-b',
            component: pivotTableComplete,
            meta: { requiresAuth: true }
        },
        {
            path: '/pvtr/:menuId/:submenuId',
            name: 'pivotTable-r',
            component: pivotTableCompleteRetail,
            meta: { requiresAuth: true }
        },


        // need to cleanup after complete menu_path migration
        {
            path: '/anomalies/:menuId/:submenuId',
            name: 'anom-home',
            component: DynamicDrilldown,
            meta: { requiresDrilldownConfig: true, requiresAuth: true }
        },
        {
            path: '/home-screen/:menuId/:submenuId',
            name: 'home-screen',
            component: HomeScreen,
            meta: { requiresAuth: true }
        },
        {
            path: '/v4-exploratory-screen/:menuId/:submenuId',
            name: 'v4-exploratory-screen',
            component: V4ExploratoryScreen,
            meta: { requiresAuth: true }
        },
        {
            path: '/business-glossary-screen/:menuId/:submenuId',
            name: 'business-glossary-screen',
            component: BusinessGlossaryScreen,
            meta: { requiresAuth: true }
        },
        {
            path: '/fwm-retailer-screen/:menuId/:submenuId',
            name: 'fwm-retail-scr',
            component: mRetailerScreen,
            meta: { requiresAuth: true }
        },

        {
            path: '/rfm/:menuId/:submenuId',
            name: 'rfm',
            component: RFM,
            meta: { requiresAuth: true }
        },
        {
            path: '/nandus_rfm/:menuId/:submenuId',
            name: 'nandus_rfm-m-s',
            component: RFM,
            meta: { requiresAuth: true }
        },
        {
            path: '/BarChart/:menuId/:submenuId',
            name: 'BarChart-m-s',
            component: BarChart,
            meta: { requiresAuth: true }
        },
        {
            path: '/menu-master-screen/:menuId/:submenuId',
            name: 'menu-master-screen',
            component: MenuMasterScreen,
            meta: { requiresAuth: true }
        },
        {
            path: '/sales-person-screen/:menuId/:submenuId',
            name: 'sales-person-screen',
            component: SalesPersonScreen,
            meta: { requiresAuth: true }
        },
        {
            path: '/viztype-screen/:menuId/:submenuId',
            name: 'viztype-screen',
            component: VizTypeScreen,
            meta: { requiresAuth: true }
        },
        {
            path: '/report-master/:menuId/:submenuId',
            name: 'report-master',
            component: ReportMasterScreen,
            meta: { requiresAuth: true }
        },
        {
            path: '/dashboard/:menuId/:submenuId',
            name: 'salesman-dashboard',
            component: salesmanDashboard,
            meta: { requiresAuth: true }
        },
        {
            path: '/category_dashboard/:menuId/:submenuId',
            name: 'category_dashboard',
            component: Page1,
            meta: { requiresAuth: true }
        },
        {
            path: '/pcat1/:menuId/:submenuId',
            name: 'pcat1',
            component: Pcat1,
            meta: { requiresAuth: true }
        },
        {
            path: '/pcat2/:menuId/:submenuId',
            name: 'pcat2',
            component: Pcat2,
            meta: { requiresAuth: true }
        },
        {
            path: '/pcat3/:menuId/:submenuId',
            name: 'pcat3',
            component: Pcat3,
            meta: { requiresAuth: true }
        },
        {
            path: '/rfm-segment/:menuId/:submenuId',
            name: 'rfm-segment',
            component: RfmSegment,
            meta: { requiresAuth: true }
        },
        {
            path: '/rfm-score/:menuId/:submenuId',
            name: 'rfm-score',
            component: RfmScore,
            meta: { requiresAuth: true }
        },
        {
            path: '/timeseries/:menuId/:submenuId',
            name: 'timeseries',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/heatmap/:menuId/:submenuId',
            name: 'heatmap',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/treemap/:menuId/:submenuId',
            name: 'treemap',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/multi-lineregression/:menuId/:submenuId',
            name: 'multi-lineregression',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/salesman-performance/:menuId/:submenuId',
            name: 'salesman-performance',
            component: seqPage,
            meta: { requiresScreenConfig: true , requiresAuth: true}
        },
        {
            path: '/multiline/:menuId/:submenuId',
            name: 'ml-1',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/pieChart/:menuId/:submenuId',
            name: 'pie-1',
            component: seqPage,
            meta: { requiresScreenConfig: true , requiresAuth: true}
        },
        {
            path: '/pieChartwithsinglecolor/:menuId/:submenuId',
            name: 'pieChartwithsinglecolor',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/mmlChartWithMultipleAxis/:menuId/:submenuId',
            name: 'mmlChartWithMultipleAxis',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/multiLineChartdualaxesXDim/:menuId/:submenuId',
            name: 'multiLineChartdualaxesXDim',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/bullet/:menuId/:submenuId',
            name: 'bull-1',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/histogram/:menuId/:submenuId',
            name: 'Histogram',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/boxplot/:menuId/:submenuId',
            name: 'iqr-category',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/grpBarChart/:menuId/:submenuId',
            name: 'grpBarChart',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/salesman-iqr/:menuId/:submenuId',
            name: 'salesman-iqr',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/parallel-coordinates/:menuId/:submenuId',
            name: 'parallel-coordinates',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/product-iqr/:menuId/:submenuId',
            name: 'product-iqr',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/map/:menuId/:submenuId',
            name: 'map',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },

        {
            path: '/horizontal-bar/:menuId/:submenuId',
            name: 'horizontal-bar',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/co-occurrence/:menuId/:submenuId',
            name: 'co-occurrence',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/dendogram/:menuId/:submenuId',
            name: 'dendogram',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/force-layout/:menuId/:submenuId',
            name: 'force-layout',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/dendogramlist/:menuId/:submenuId',
            name: 'dendogramlist',
            component: dendropdownpage,
            meta: { requiresAuth: true }
        },
        {
            path: '/paretochart/:menuId/:submenuId',
            name: 'paretochart',
            component: Page,
            meta: { requiresAuth: true }
        },
        {
            path: '/dotplot/:menuId/:submenuId',
            name: 'dotplot',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/collapsible/:menuId/:submenuId',
            name: 'collapsible',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/mba-freq-txn/:menuId/:submenuId',
            name: 'mba-freq-txn',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/mba-freq-itemset/:menuId/:submenuId',
            name: 'mba-freq-itemset',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/mba-nw-graph/:menuId/:submenuId',
            name: 'mba-nw-graph',
            component: MBAnwGraph,
            meta: { requiresAuth: true }
        },
        {
            path: '/mba-recommend-item/:menuId/:submenuId',
            name: 'recommend-item',
            component: simpleReportPage,
            meta: { requiresAuth: true }
        },
        {
            path: '/source-treemap/:menuId/:submenuId',
            name: 'source-treemap',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/waterfall/:menuId/:submenuId',
            name: 'waterfall',
            component: seqPage,
            meta: { requiresScreenConfig: true , requiresAuth: true}
        },
        {
            path: '/correlogram/:menuId/:submenuId',
            name: 'correlogram',
            component: seqPage,
            meta: { requiresScreenConfig: true , requiresAuth: true}
        },
        {
            path: '/tinyradialtree/:menuId/:submenuId',
            name: 'tinyradialtree',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/force-directed/:menuId/:submenuId',
            name: 'force-directed',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/miserable/:menuId/:submenuId',
            name: 'miserable',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/miserable-enterprise/:menuId/:submenuId',
            name: 'miserable-enterprise',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/metricgraphics-annotations/:menuId/:submenuId',
            name: 'metricgraphics-annotations',
            component: Page,
            meta: { requiresAuth: true }
        },
        {
            path: '/nandus_rfm/:menuId/:submenuId',
            name: 'nandus_rfm',
            component: RFM,
            meta: { requiresAuth: true }
        },
        {
            path: '/metricgraphics-timeformat/:menuId/:submenuId',
            name: 'metricgraphics-timeformat',
            component: seqPage,
            meta: { requiresScreenConfig: true , requiresAuth: true}
        },
        {
            path: '/metricgraphics-updating/:menuId/:submenuId',
            name: 'metricgraphics-updating',
            component: updating_metricspage,
            meta: { requiresAuth: true }
        },
        {
            path: '/simple-bar-chart/:menuId/:submenuId',
            name: 'simple-bar-chart',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/simple-bar-chart-line/:menuId/:submenuId',
            name: 'simple-bar-chart-line',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/line-chart/:menuId/:submenuId',
            name: 'line-chart',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/line-chart-plots/:menuId/:submenuId',
            name: 'line-chart-plots',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/sankey-plot/:menuId/:submenuId',
            name: 'sankey-plot',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/new-sankey-plot/:menuId/:submenuId',
            name: 'new-sankey-plot',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/group-bar-plots/:menuId/:submenuId',
            name: 'group-bar-plots',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/multi-bar/:menuId/:submenuId',
            name: 'multi-bar',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/multi-line-dim/:menuId/:submenuId',
            name: 'multi-line-dim',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/stacked-grouped/:menuId/:submenuId',
            name: 'stacked-grouped',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/horizontal-boxplot/:menuId/:submenuId',
            name: 'horizontal-boxplot',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/candle-stick/:menuId/:submenuId',
            name: 'candle-stick',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/table-bar/:menuId/:submenuId',
            name: 'table-bar',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/table-with-bar/:menuId/:submenuId',
            name: 'table-with-bar',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/table-with-bar-line/:menuId/:submenuId',
            name: 'table-with-bar-line',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/multiple-pie/:menuId/:submenuId',
            name: 'multiple-pie',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/multiple-pie-2/:menuId/:submenuId',
            name: 'multiple-pie-2',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/drilldown-a1/:menuId/:submenuId',
            name: 'drilldown-a1',
            component: DrilldownA1,
            meta: { requiresAuth: true }
        },
        {
            path: '/drilldown-a/:menuId/:submenuId',
            name: 'drilldown-a',
            component: DrilldownA,
            meta: { requiresAuth: true }
        },
        {
            path: '/drilldown-b1/:menuId/:submenuId',
            name: 'drilldown-b1',
            component: DrilldownB1,
            meta: { requiresAuth: true }
        },
        {
            path: '/drilldown-b/:menuId/:submenuId',
            name: 'drilldown-b',
            component: DrilldownB,
            meta: { requiresAuth: true }
        },
        {
            path: '/z-old-customer-drilldown/:menuId/:submenuId',
            name: 'customer-drilldown',
            component: CustomerDrilldown,
            meta: { requiresAuth: true }
        },
        {
            path: '/z-old-product-drilldown/:menuId/:submenuId',
            name: 'product-drilldown',
            component: ProductDrilldown,
            meta: { requiresAuth: true }
        },
        {
            path: '/z-old-sales-man-drilldown/:menuId/:submenuId',
            name: 'sales-man-drilldown',
            component: SalesmanDrilldown,
            meta: { requiresAuth: true }
        },
        {
            path: '/customer-drilldown-dyn/:menuId/:submenuId',
            name: 'customer-drilldown-m-s',
            component: DynamicDrilldown,
            meta: { requiresDrilldownConfig: true , requiresAuth: true}
        },
        {
            path: '/product-drilldown-dyn/:menuId/:submenuId',
            name: 'product-drilldown-m-s',
            component: DynamicDrilldown,
            meta: { requiresDrilldownConfig: true, requiresAuth: true }
        },
        {
            path: '/sales-man-drilldown-dyn/:menuId/:submenuId',
            name: 'sales-man-drilldown-dyn',
            component: DynamicDrilldown,
            meta: { requiresDrilldownConfig: true, requiresAuth: true }
        },
        {
            path: '/file-drilldown-dyn/:menuId/:submenuId',
            name: 'file-drilldown',
            component: DynamicDrilldown,
            meta: { requiresDrilldownConfig: true, requiresAuth: true }
        },
        {
            path: '/next-best-report/:menuId/:submenuId',
            name: 'next-best-report',
            component: simpleReportPage,
            meta: { requiresAuth: true }
        },
        {
            path: '/customer-monthly-sales/:menuId/:submenuId',
            name: 'customer-monthly-sales',
            component: simpleReportPage,
            meta: { requiresAuth: true }
        },
        {
            path: '/travels-report/:menuId/:submenuId',
            name: 'travels-report',
            component: simpleReportPage,
            meta: { requiresAuth: true }
        },
        {
            path: '/vehicle-report/:menuId/:submenuId',
            name: 'vehicle-report',
            component: simpleReportPage,
            meta: { requiresAuth: true }
        },
        {
            path: '/multiple-company/:menuId/:submenuId',
            name: 'multiple-company',
            component: simpleReportPage,
            meta: { requiresAuth: true }
        },
        {
            path: '/revenue-split/:menuId/:submenuId',
            name: 'revenue-split',
            component: simpleReportPage,
            meta: { requiresAuth: true }
        },
        {
            path: '/revenue-by-agency/:menuId/:submenuId',
            name: 'revenue-by-agency',
            component: simpleReportPage,
            meta: { requiresAuth: true }
        },
        {
            path: '/revenue-by-vehicleType/:menuId/:submenuId',
            name: 'revenue-by-vehicleType',
            component: simpleReportPage,
            meta: { requiresAuth: true }
        },
        {
            path: '/nandus-simple-report/:menuId/:submenuId',
            name: 'nandus-simple-report',
            component: simpleReportPage,
            meta: { requiresAuth: true }
        },
        {
            path: '/annotation-messages/:menuId/:submenuId',
            name: 'annotation-messages',
            component: simpleReportPage,
            meta: { requiresAuth: true }
        },
        {
            path: '/circlepacking/:menuId/:submenuId',
            name: 'circlepacking',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/hierarchial_bar/:menuId/:submenuId',
            name: 'hierarchial_bar',
            component: seqPage,
            meta: { requiresScreenConfig: true , requiresAuth: true}
        },
        {
            path: '/marimekko/:menuId/:submenuId',
            name: 'marimekko',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/productcategorybymonth/:menuId/:submenuId',
            name: 'productcategorybymonth',
            component: seqPage,
            meta: { requiresScreenConfig: true , requiresAuth: true}
        },
        {
            path: '/monthbyproductcategory/:menuId/:submenuId',
            name: 'monthbyproductcategory',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/multipleLineChart/:menuId/:submenuId',
            name: 'multipleLineChart',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/smallmultipleLineCharts/:menuId/:submenuId',
            name: 'smallmultipleLineCharts',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/monthonmonthsalesbyproductcategory/:menuId/:submenuId',
            name: 'monthonmonthsalesbyproductcategory',
            component: seqPage,
            meta: { requiresScreenConfig: true , requiresAuth: true}
        },
        {
            path: '/crossfilter/:menuId/:submenuId',
            name: 'crossfilter-page',
            component: Crossfilter,
            meta: { requiresAuth: true }
        },
        {
            path: '/crossfilter-dc/:menuId/:submenuId',
            name: 'crossfilterdc-page',
            component: Crossfilterdc,
            meta: { requiresAuth: true }
        },
        {
            path: '/horizontalbar-epidemics/:menuId/:submenuId',
            name: 'horizontalbar-page',
            component: Horizontalbar,
            meta: { requiresAuth: true }
        },
        {
            path: '/drilldown-report/:menuId/:submenuId',
            name: 'travels-drilldown-dyn',
            component: DynamicDrilldown,
            meta: { requiresDrilldownConfig: true, requiresAuth: true }
        },
        {
            path: '/travels-home/:menuId/:submenuId',
            name: 'travels-home',
            component: TravelsHomeDashboard,
            meta: { requiresAuth: true }
        },
        {
            path: '/new-menu/:menuId/:submenuId',
            name: 'nwm',
            component: Page,
            meta: { requiresAuth: true }
        },
        {
            path: '/new-story/:menuId/:submenuId',
            name: 'nwm-1',
            component: Page1,
            meta: { requiresAuth: true }
        },
        {
            path: '/beeswarm/:menuId/:submenuId',
            name: 'beeswarm',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/beeswarm-chart/:menuId/:submenuId',
            name: 'beeswarmcomp',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true}
        },
        {
            path: '/xy-drilldown/:menuId/:submenuId',
            name: 'xy-drilldown',
            component: XYDrilldown,
            meta: { requiresAuth: true }
        },
        {
            path: '/ts-trend-seasonal/:menuId/:submenuId',
            name: 'ts-trend-seasonal',
            component: Page,
            meta: { requiresAuth: true }
        },
        {
            path: '/ts1-trend-seasonal/:menuId/:submenuId',
            name: 'ts1-trend-seasonal',
            component: TogglePage,
            meta: { requiresAuth: true }
        },
        {
            path: '/leafletMapPopup/:menuId/:submenuId',
            name: 'LeafletPlot',
            component: leafletMapPopup,
            meta: { requiresAuth: true }
        },
        {
            path: '/newmapleaflet/:menuId/:submenuId',
            name: 'newmapleaflet',
            component: newmapleaflet,
            meta: { requiresAuth: true }
        },
        {
            path: '/pareto/:menuId/:submenuId',
            name: 'pareto',
            component: seqPage,
            meta: { requiresScreenConfig: true, requiresAuth: true }
        },
        {
            path: '/pvtd/:menuId/:submenuId',
            name: 'pivotTable-m-s',
            component: pivotTableCompleteDuroflex,
            meta: { requiresAuth: true }
        },
        {
            path: '/simple-report-pagination/:menuId/:submenuId',
            name: 'simple-reportPage-pagination',
            component: singleReportPagination,
            meta: { requiresAuth: true }
        },
        {
            path: '/tabulator-rep-table/:menuId/:submenuId',
            name: 'tabulator-report-table',
            component: tabulatorReportTable,
            meta: { requiresAuth: true }
        },
        {
            path: '/image-display/:txnId',
            name: 'image-display',
            component: imageDisplay,
            meta: { requiresAuth: true }
        },
        {
            path: '/s3-display/:filename',
            name: 's3-display',
            component: imageDisplay,
            meta: { requiresAuth: true }
        },
        {
            path: '/bsl-api/:menuId/:submenuId',
            name: 'bsl-api-page',
            component: bslAPiPage,
            meta: { requiresAuth: true }
        },
        {
            path:'/field/deepdive',
            name:'field-deepdive',
            component:mobileDashboardPage,
            meta: { requiresAuth: true }
        },
        {
            path:'/field/simple',
            name:'field-simple',
            component:mobileDashboardPage,
            meta: { requiresAuth: true }
        },
        {
            path:'/field/landing',
            name:'field-landing',
            component:mobileDashboardPage,
            meta: { requiresAuth: true }
        },
        {
            path:'/mobile-screen',
            name:'mobile-screen',
            component:mobileDashboardPage,
            meta: { requiresAuth: true }
        },
        {
            path:"/config-menu/:menuId/:submenuId",
            name:'config-menu',
            component:configMenu,
            meta: { requiresAuth: true }
        },
    ]
})




router.beforeEach(async (to, from, next) => {
    // Prevent infinite loop - if we're already going to user-restrict, allow it
    if (to.name === 'user-restrict') {
        return next();
    }

    if (store.state.isLoggedIn && store.state.isAppMenuAndAppHeaderDisplay) {
        let at = store.state.authToken
        console.log("token", at)
        let decoded = jwtDecode(at)
        console.log("decoded", decoded)
        if (Date.now() >= decoded['exp'] * 1000) {
            console.error('Router AuthToken Expired, lets logout')
            if (to.matched.some(record => record.meta.requiresAuth)) {
                sessionStorage.setItem('returnUrl', to.fullPath);
            }
            store.commit('loggedOut')
            await router.push('/login')
            return;
        }

        //wait for state before we go to any pages
        console.log(`user is logged in, now we will load state THEN proceed to page load, from[${from.path}] To[${to.path}]`)
        await store.dispatch("loadState")
        console.log("router for each", from, store.state.user.userRoleRestriction.menuAccessInclusionArray)

        let restrictedMenu = store.state.user.userRoleRestriction.menuAccessInclusionArray || []
        let exclusionArray = store.state.user.userRoleRestriction.menuAccessExclusionArray || [];

        // Handle empty/undefined/null/["[]"] cases - all menus allowed
        const isAllMenusAllowed = !restrictedMenu ||
            restrictedMenu.length === 0 ||
            (restrictedMenu.length === 1 && restrictedMenu[0] === "[]")

        if (isAllMenusAllowed) {
            // All menus are allowed, proceed
            next();
        } else {
            const menuTree = store.state.menuMasterData.filter(m => m.parentMenuId === 'Root') || []
            console.log("menu",menuTree)
            // Check if current menu is allowed
            const currentMenuId = to.params.menuId
            const currentSubmenuId = to.params.submenuId

            // Only apply restrictions for routes that have menuId/submenuId parameters
            // If this route doesn't have these params, allow access
            if (!currentMenuId && !currentSubmenuId) {
                console.log("Route doesn't have menu restrictions - allowing access")
                return next();
            }

            // Check if current IDs are in exclusion array
            const isExcluded = exclusionArray.includes(currentMenuId) ||
                exclusionArray.includes(currentSubmenuId)

            // Check whether current IDs are directly allowed or descendants of allowed ones
            const isAllowed =
                restrictedMenu.includes(currentMenuId) ||
                restrictedMenu.includes(currentSubmenuId) ||
                isDescendant(menuTree, restrictedMenu, currentMenuId) ||
                isDescendant(menuTree, restrictedMenu, currentSubmenuId);


            if (!isAllowed || isExcluded) {
                console.log("Current Menu is not allowed - redirecting to user-restrict")
                await router.push('/user-restrict')
                return;
            } else {
                console.log("Menu is allowed - proceeding")
                next();
            }
        }

    } else if (to.name !== 'login' && to.name !== 'field-landing' && to.name !== 'field-deepdive' && to.name !== 'field-simple' && to.name !== 'forgetpass') {
        console.log("Else router", to, from, next)
        if (to.matched.some(record => record.meta.requiresAuth)) {
            sessionStorage.setItem('returnUrl', to.fullPath);
        }
        await router.push('/login')
    } else {
        console.log("Proceeding to route", to.name, "with path", to.path)
        return next()
    }
})
export default router